export default __webpack_public_path__ + "static/addie-92da60cf55fbf03c467ef58d900aa68e.png";